import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { transportationTabs, TransportationTabId } from './TransportationTabs';
import styles from './TransportationNavbar.module.scss';

interface TransportationNavbarProps {
    selectedTab: TransportationTabId;
    onTabChange: (tabId: TransportationTabId) => void;
}

export const TransportationNavbar: React.FC<TransportationNavbarProps> = ({ selectedTab, onTabChange }) => {
    return (
        <div className={styles.root}>
            <p className={styles.title}>Transportation</p>

            <nav className={styles.menu}>
                {transportationTabs.map(tab => (
                    <button
                        key={tab.id}
                        onClick={() => onTabChange(tab.id)}
                        className={styles.menuLink}
                        aria-current={selectedTab === tab.id ? 'page' : undefined}
                    >
                        <FontAwesomeIcon icon={tab.icon} />
                        {tab.name}
                    </button>
                ))}
            </nav>
        </div>
    );
};
